var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col" },
      [
        _c("card-container", {
          attrs: {
            title: _vm.$router.currentRoute.meta.title,
            headers: _vm.tableHeaders,
            lastPage: _vm.lastPage,
            totalElements: _vm.totalElements,
            currentPage: _vm.getCurrentPage(),
            clickHandler: _vm.pagination
          },
          scopedSlots: _vm._u([
            {
              key: "card-header",
              fn: function() {
                return [
                  _c(
                    "router-link",
                    {
                      directives: [
                        {
                          name: "can",
                          rawName: "v-can:add",
                          value: _vm.permissionPrefix,
                          expression: "permissionPrefix",
                          arg: "add"
                        }
                      ],
                      staticClass: "btn btn-primary btn-sm",
                      attrs: { to: { name: _vm.routePrefix + ".create" } }
                    },
                    [_c("i", { staticClass: "fa fa-plus" })]
                  )
                ]
              },
              proxy: true
            },
            {
              key: "card-header-search",
              fn: function() {
                return [
                  _c("search", {
                    attrs: { listHandler: _vm.getList },
                    model: {
                      value: _vm.lastPage,
                      callback: function($$v) {
                        _vm.lastPage = $$v
                      },
                      expression: "lastPage"
                    }
                  })
                ]
              },
              proxy: true
            },
            {
              key: "table-rows",
              fn: function() {
                return [
                  _vm._l(_vm.items, function(item) {
                    return _c(
                      "tr",
                      { key: item.id },
                      [
                        _c("td", [
                          _c(
                            "div",
                            { staticClass: "media align-items-center" },
                            [
                              _vm.getImageThumbnail(item)
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "avatar rounded-circle",
                                      attrs: { href: "javascript:;" }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          alt: "Image placeholder",
                                          src: _vm.getImageThumbnail(item)
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "media-body" }, [
                                _c("span", { staticClass: "name mb-0 text-sm" })
                              ])
                            ]
                          )
                        ]),
                        _c("td", [_vm._v(" " + _vm._s(item.name) + " ")]),
                        _c("td", [_vm._v(" " + _vm._s(item.type) + " ")]),
                        _c("td", [
                          _vm.canEditFleet
                            ? _c(
                                "select",
                                {
                                  staticClass:
                                    "form-control form-control-sm supplier-fleet-select",
                                  attrs: { id: "fleet_" + item.id },
                                  domProps: { value: item.fleet || "" },
                                  on: {
                                    change: function($event) {
                                      return _vm.changeFleet(item, $event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "", disabled: "" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("lists.supplier_fleet.NOT_SET")
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._l(_vm.fleets, function(fleet) {
                                    return _c(
                                      "option",
                                      {
                                        key: fleet,
                                        domProps: { value: fleet }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "lists.supplier_fleet." + fleet
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            : _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "lists.supplier_fleet." +
                                        (item.fleet || "NOT_SET")
                                    )
                                  )
                                )
                              ])
                        ]),
                        _c(
                          "td",
                          [
                            _c("input-checkbox", {
                              attrs: {
                                options: {
                                  id: "wallet_enabled",
                                  onChangeHandler:
                                    _vm.changeWalletEnabledStatus,
                                  onChangeParams: {
                                    id: item.id,
                                    value: !item.usesWallet
                                  },
                                  fullLayout: false
                                }
                              },
                              model: {
                                value: item.usesWallet,
                                callback: function($$v) {
                                  _vm.$set(item, "usesWallet", $$v)
                                },
                                expression: "item.usesWallet"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            _c("input-checkbox", {
                              attrs: {
                                options: {
                                  id: "full_time_drivers",
                                  onChangeHandler:
                                    _vm.changeFullTimeDriversStatus,
                                  onChangeParams: {
                                    id: item.id,
                                    value: !item.fullTimeDrivers
                                  },
                                  fullLayout: false,
                                  disabled:
                                    item.type === "CAPTAINS_BRAND_DEDICATED"
                                }
                              },
                              model: {
                                value: item.fullTimeDrivers,
                                callback: function($$v) {
                                  _vm.$set(item, "fullTimeDrivers", $$v)
                                },
                                expression: "item.fullTimeDrivers"
                              }
                            })
                          ],
                          1
                        ),
                        _c("td", { staticClass: "text-direction-ltr" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("moment")(
                                  item.createdAt,
                                  "Y-MM-DD hh:mm:ss A"
                                )
                              ) +
                              " "
                          )
                        ]),
                        _c("table-item-actions", {
                          attrs: {
                            actions: _vm.tableItemActions,
                            params: { id: item.id }
                          }
                        })
                      ],
                      1
                    )
                  }),
                  !_vm.items.length
                    ? _c("tr", { staticClass: "text-center" }, [
                        _c("td", { attrs: { colspan: "999" } }, [
                          _vm._v(_vm._s(_vm.$t("messages.no_result_found")))
                        ])
                      ])
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }